import { Field, ID, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType, Severity } from '@typegoose/typegoose'
import { Asset, BaseEntity, Contact, generateEntityId } from '@ztechapps/common.contract'
import GraphQLJSON from 'graphql-type-json'
import { HaulerDriverSettings } from './HaulerDriverSettings'
import { HaulerSignature } from './HaulerSignature'
import { HaulerLogo } from './HaulerLogo'
import { MilkPickupHaulerRef } from './MilkPickupHaulerRef'

@modelOptions({ schemaOptions: { strict: false }, options: { allowMixed: Severity.ALLOW } })
@ObjectType()
export class HaulerDriver extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('hdrv') })
  declare _id: string

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  samplerLicenseNo?: string

  @Field(() => HaulerSignature, { nullable: true })
  @Prop({ type: HaulerSignature })
  signature?: ReturnType<() => HaulerSignature>

  @Field(() => MilkPickupHaulerRef, { nullable: true })
  @Prop({ type: MilkPickupHaulerRef })
  hauler?: ReturnType<() => MilkPickupHaulerRef>

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  licenseNoExpirationDate?: Date

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  ticketHaulerName?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  ticketHaulerAddress?: string

  @Field(() => [Asset], { nullable: true })
  @Prop({ type: [Asset] }, PropType.ARRAY)
  assets?: ReturnType<() => Asset[]>

  @Field(() => HaulerDriverSettings, { nullable: true })
  @Prop({ type: HaulerDriverSettings })
  settings?: ReturnType<() => HaulerDriverSettings>

  @Field(() => GraphQLJSON, { nullable: true })
  templateData?: Record<string, unknown>
}
